import { Controller } from "@hotwired/stimulus";

export class StripePaymentController extends Controller {
  static targets = ["element", "submit", "error", "country", "locationError"];
  static values = {
    publishableKey: String,
    clientSecret: String,
    returnUrl: String,
    locationRequiredMessage: String,
  };

  connect() {
    this.paymentComplete = false;
    this.stripe = window.Stripe(this.publishableKeyValue);
    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
    });
    this.paymentElement = this.elements.create("payment", {
      layout: "tabs",
      fields: { billingDetails: { address: { country: "never" } } },
    });
    this.paymentElement.on("change", (event) => {
      this.paymentComplete = event.complete;
      this.updateSubmitState();
    });
    this.paymentElement.mount(this.elementTarget);
    this.updateSubmitState();
  }

  disconnect() {
    this.paymentElement?.destroy();
  }

  clearLocationError() {
    if (this.countryTarget.value) {
      this.locationErrorTarget.textContent = "";
    }
    this.updateSubmitState();
  }

  updateSubmitState() {
    this.submitTarget.disabled = !(
      this.paymentComplete && this.countryTarget.value
    );
  }

  async submit(event) {
    event.preventDefault();

    if (!this.countryTarget.value) {
      this.locationErrorTarget.textContent = this.locationRequiredMessageValue;
      return;
    }

    this.submitTarget.disabled = true;
    this.errorTarget.textContent = "";

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: this.returnUrlValue,
        payment_method_data: {
          billing_details: {
            address: { country: this.countryTarget.value },
          },
        },
      },
    });

    if (error) {
      this.errorTarget.textContent = error.message;
      this.updateSubmitState();
    }
  }
}
